<template>
  <v-container fluid>
    <v-row v-if="viewoption == 'cancel'">
      <CancelRegistration :accesscode="accesscode" :username="username"/>
    </v-row>
    <v-row v-if="viewoption == 'normal'">
      <v-col cols="12" v-if="this.$store.getters.isLoggedIn">
        <SelectEvent v-if="viewoption != 'cancel'" />
      </v-col>
      <v-col cols="12" v-else>
        <LoginPrompt />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SelectEvent from "@/components/SelectEvent";
import LoginPrompt from "@/components/LoginPrompt";
import CancelRegistration from "@/components/CancelRegistration";

export default {
  components: {
    SelectEvent,
    LoginPrompt,
    CancelRegistration,
  },
  props: {
    viewoption: {
      type: String,
      required: false,
      default: "normal",
    },
    accesscode: {
      type: String,
      required: false,
      default: "",
    },
    username: {
      type: String,
      required: false,
      default: "none",
    },
  },
};
</script>
